export enum PeriodFilterValuesEnum {
  'day' = 'Recentes',
  'week' = 'Esta semana',
  'month' = 'Este mês',
}
